module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if( player ) { 
__p+='\n	<div class="filter-players">\n		<!--<div class="form-group">-->\n		<!--<input class="base-input" placeholder="Search Players" />-->\n		<!--<a href="javascript:void(0)" class="search js-search-league-by-pin ion-ios-search-strong"></a>-->\n		<!--</div>-->\n\n		<div class="form-group">\n			<select class="base-select js-select-team">\n				<option class="hidden">Select team</option>\n				';
 _.each(squads, function(squad) { 
__p+='\n					<option\n						value="'+
((__t=( squad.id ))==null?'':_.escape(__t))+
'"\n						'+
((__t=( player.squad_id==squad.id ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					>\n						'+
((__t=( squad.name ))==null?'':_.escape(__t))+
'\n					</option>\n				';
 }) 
__p+='\n			</select>\n		</div>\n\n		<div class="form-group">\n			<select class="base-select js-select-player">\n				<option class="hidden">Select player</option>\n				';
 _.each(players, function(item) { 
__p+='\n					<option\n						value="'+
((__t=( item.id ))==null?'':_.escape(__t))+
'"\n						data-id="'+
((__t=( player.id ))==null?'':_.escape(__t))+
'"\n						'+
((__t=( player.id==item.id ? 'selected' : '' ))==null?'':_.escape(__t))+
'\n					>\n						'+
((__t=( item.first_name ))==null?'':_.escape(__t))+
' '+
((__t=( item.last_name ))==null?'':_.escape(__t))+
'\n					</option>\n				';
 }) 
__p+='\n			</select>\n		</div>\n	</div>\n\n	<div class="current-player-container squad-'+
((__t=( player.squad_id ))==null?'':_.escape(__t))+
'">\n		<div class="player-main-info">\n			<div class="squad-silhouette" style="background-image: url(/assets/images/squad-logos/'+
((__t=( player.squad_id ))==null?'':_.escape(__t))+
'.svg);"></div>\n			<div class="player-description">\n				<p class="name">'+
((__t=( player.first_name ))==null?'':_.escape(__t))+
'</p>\n				<p class="full-name">'+
((__t=( player.last_name ))==null?'':_.escape(__t))+
'</p>\n				<div class="cost">\n					'+
((__t=( _.currencyFormat(player.cost, '$', true) ))==null?'':_.escape(__t))+
'\n				</div>\n				<p class="squad-pos">\n					<strong>\n						'+
((__t=( player.squad_name ))==null?'':_.escape(__t))+
'\n					</strong> |\n					'+
((__t=( player.position_names.join(', ') ))==null?'':_.escape(__t))+
'\n				</p>\n\n				<div class="btns">\n					<a href="https://www.nrl.com/players/nrl-premiership/'+
((__t=( external_link ))==null?'':_.escape(__t))+
'"\n					   target="_blank"\n					   class="tertiary-btn external"\n					>\n						See <span class="hidden-mobile">Player Profile</span> on NRL.com\n					</a>\n					';
 if (is_authorized) { 
__p+='\n					<div class="tertiary-btn '+
((__t=( is_favourite ? 'active' : '' ))==null?'':_.escape(__t))+
' js-add-to-favourites">\n						<span class="remove-favourites">Remove from favourites</span>\n						<span class="add-favourites">Add to watch list</span>\n					</div>\n					';
 } 
__p+='\n				</div>\n			</div>\n			<div class="player-avatar">\n				';
 if( player.id ) { 
__p+='\n					<picture>\n						<source srcset="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 450, format: 'webp' }) ))==null?'':_.escape(__t))+
'"\n								type="image/webp"/>\n						<img src="'+
((__t=( _.getPlayerAvatarUrl({ id: player.id, size: 450 }) ))==null?'':_.escape(__t))+
'"\n							onerror="if (this.src != \'player-icon.png\') this.src = \'player-icon.png\';"\n							 alt="'+
((__t=( player.first_name + ' ' + player.last_name ))==null?'':_.escape(__t))+
'"/>\n					</picture>\n				';
 } 
__p+='\n			</div>\n		</div>\n	</div>\n	<ul class="stats-navigation">\n		<li class="js-change-stats active" data-stats="general-stats">\n			General Stats\n		</li>\n		<li class="js-change-stats" data-stats="fixtures-stats">\n			Fixtures\n		</li>\n		<li class="js-change-stats" data-stats="match-stats">\n			Match Stats\n		</li>\n		';
 if (is_authorized) { 
__p+='\n\n		<li class="coach-stat '+
((__t=( !has_assistant_coach ? 'js-coach-locked' : 'js-change-stats' ))==null?'':_.escape(__t))+
'"\n			data-stats="opponents-stats">\n			Opponents\n		</li>\n		<li class="coach-stat '+
((__t=( !has_assistant_coach ? 'js-coach-locked' : 'js-change-stats' ))==null?'':_.escape(__t))+
'"\n			data-stats="venues-stats">\n			Venues\n		</li>\n		';
 } 
__p+='\n\n	</ul>\n	<div id="player-stats"></div>\n';
 } 
__p+='\n';
}
return __p;
};
